import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppService } from '@app/app.service';
import { AppBreadcrumbsService } from '@app/layout/breadcrumbs/services/app-breadcrumbs.service';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['../styles/breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
    public appService = inject(AppService);
    public service = inject(AppBreadcrumbsService);

    /**
     * TrackBy для перебора хлебных крошек
     * @param item - элемент хлебных крошек
     */
    public readonly trackByLink = (item) => item?.link;
}
